import { render, staticRenderFns } from "./RoomHousekeepingDetailTab.vue?vue&type=template&id=0e8511f1"
import script from "./RoomHousekeepingDetailTab.vue?vue&type=script&lang=js"
export * from "./RoomHousekeepingDetailTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports